import { Card, Table, Pagination } from "react-bootstrap";
import { RiArrowRightSLine } from "react-icons/ri";
import React, { useState } from "react";
import CustomPagination from "../common/CustomPagination";
import moment from "moment";

function RecentTransactions({ transactions, pagination, pageHandler }) {

  return (<>

    {/* TABLE */}
    <div className={`${pagination?.limit === 10 ? "lp-table-wrapper mb-3" : ""} `}>
      <Table responsive className="rt-table align-middle">

        <thead>
          <tr>
            <th>Date</th>
            <th>Description</th>
            <th>Amount</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody className="text-start">
          {transactions?.length > 0 ? (
            transactions.map((item, i) => (
              <tr key={i}>

                <td className="dates">
                  {moment(item?.createdAt).local().format("MMM DD, YYYY h:mm A")}
                </td>

                <td className="desc">
                  {/* {item.description}{item?.xeroInvoiceNumber || "-"} */}
                  {item?.xeroInvoiceNumber ? item?.xeroInvoiceNumber : item?.lineItems?.[0]?.description?.split('\n')[0] }
                </td>

                <td className={`fw-semibold`}>
                  ${item?.totalAmount?.toFixed(2) || "-"}
                </td>

                <td>
                  <span className={`status completed`}>
                    completed
                  </span>
                </td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className="text-center py-4">
                No transactions found.
              </td>
            </tr>
          )}
        </tbody>

      </Table>
    </div>

    {/* 🔥 PAGINATION */}
    <CustomPagination
      pagination={pagination}
      pageHandler={pageHandler}
    />
  </>
  );
}

export default React.memo(RecentTransactions);